module.exports = __webpack_public_path__ + "assets/App-Resume-Icon.svg";